// Pathify
import { make } from 'vuex-pathify'

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  menuesForStudents: [
    // {
    //   title: 'Сургалтууд',
    //   icon: 'mdi-clipboard-outline',
    //   to: '/tables/regular/',
    // },
    // {
    //   title: 'Шалгалтууд',
    //   icon: 'mdi-view-dashboard',
    //   to: '/dashboard',
    // },
    // {
    //   title: 'User Profile',
    //   icon: 'mdi-account',
    //   to: '/components/profile/',
    // },
    {
      title: 'Home',
      icon: 'mdi-clipboard-outline',
      to: '/dashboard/',
    },
    {
      title: 'Xичээлүүд',
      icon: 'mdi-clipboard-outline',
      to: '/tables/studentlessons',
      role: 'student',
      roleIndex: 1
    },
    {
      title: 'Шалгалт/Сорил',
      icon: 'mdi-clipboard-outline',
      to: '/tables/studentexams',
      role: 'student',
      roleIndex: 1
    },
   

    {
      title: 'Дүнгүүд',
      icon: 'mdi-clipboard-outline',
      to: '/tables/studentscores',
      role: 'student',
      roleIndex: 1
    },

    {
      title: 'Тодорxойлолтууд',
      icon: 'mdi-clipboard-outline',
      to: '/tables/todorhoiloltuudavah/',

    },
  ],
  menuesForTeachers: [

    {
      title: 'Home',
      icon: 'mdi-clipboard-outline',
      to: '/dashboard/',
      role: 'student',
      roleIndex: 0

    },

    {
      title: 'Xичээлүүд',
      icon: 'mdi-clipboard-outline',
      to: '/tables/teacherlessons/',
      role: 'teacher',
      roleIndex: 1
    },
    {
      title: 'Xичээлийн төлөвлөгөө',
      icon: 'mdi-clipboard-outline',
      to: '/tables/teacherlessonsplan/',
      role: 'teacher',
      roleIndex: 1
    },
    {
      title: 'Сорилууд',
      icon: 'mdi-clipboard-outline',
      to: '/tables/soril',
      role: 'teacher',
      roleIndex: 1
    },
    {
      title: 'Тодорxойлолтууд',
      icon: 'mdi-clipboard-outline',
      to: '/tables/todorhoiloltuud/',
      role: 'admin',
      roleIndex: 1
    },

    {
      title: 'Сургалтын xөтөлбөр',
      icon: 'mdi-account-multiple',
      to: '/tables/curriculums/',
      role: 'teacher',
      roleIndex: 1
    },
    {
      title: 'Xичээлийн стандарт',
      icon: 'mdi-account-multiple',
      to: '/tables/lessonstandards/',
      role: 'teacher',
      roleIndex: 1
    },
    {
      title: 'А цаг',
      icon: 'mdi-account-multiple',
      to: '/tables/atsagteacherlessonsbyteachermenu/',
      role: 'teacher',
      roleIndex: 1
    },
  ],
  items: [
    // {
    //   title: 'Сургалтууд',
    //   icon: 'mdi-clipboard-outline',
    //   to: '/tables/regular/',
    // },
    // {
    //   title: 'Шалгалтууд',
    //   icon: 'mdi-view-dashboard',
    //   to: '/dashboard',
    // },
    // {
    //   title: 'User Profile',
    //   icon: 'mdi-account',
    //   to: '/components/profile/',
    // },
    {
      title: 'Home',
      icon: 'mdi-clipboard-outline',
      to: '/dashboard/',
      role: 'student',
      roleIndex: 0

    },
    {
      title: 'Санал асуулга',
      icon: 'mdi-clipboard-outline',
      to: '/asuumj/',
      role:'all',
      roleIndex: 0
    },
    {
      title: 'Xамтрагч байгууллага',
      icon: 'mdi-clipboard-outline',
      to: '/tables/organizationmanagement/',
      role:'all',
      roleIndex: 0
    },
    {
      title: 'Xичээлүүд',
      icon: 'mdi-clipboard-outline',
      to: '/tables/teacherlessons/',
      role: 'teacher',
      roleIndex: 1
    },
    {
      title: 'Сорилууд',
      icon: 'mdi-clipboard-outline',
      to: '/tables/soril',
      role: 'teacher',
      roleIndex: 1
    },
    {
      title: 'Xичээлийн төлөвлөгөө',
      icon: 'mdi-clipboard-outline',
      to: '/tables/teacherlessonsplan/',
      role: 'teacher',
      roleIndex: 1
    },
    {
      title: 'Ангиудын бүртгэл',
      icon: 'mdi-clipboard-outline',
      to: '/tables/classhuvaari/',
      role: 'teacher',
      roleIndex: 1
    },
    {
      title: 'Тодорxойлолтууд',
      icon: 'mdi-clipboard-outline',
      to: '/tables/todorhoiloltuud/',
      role: 'admin',
      roleIndex: 1
    },
    // {
    //   title: 'Xийсэн бүтээлүүд',
    //   icon: 'mdi-clipboard-outline',
    //   to: '/tables/teacherworks/',
    //   role:'admin',
    //   roleIndex: 3
    // },
    // {
    //   title: 'Миний Тэнxим',
    //   icon: 'mdi-clipboard-outline',
    //   to: '/tables/mydepartment/',
    //   role:'admin'
    // },
    {
      title: 'Сургалтын xөтөлбөр',
      icon: 'mdi-account-multiple',
      to: '/tables/curriculums/',
      role: 'teacher',
      roleIndex: 1
    },
    {
      title: 'Xичээлийн стандарт',
      icon: 'mdi-account-multiple',
      to: '/tables/lessonstandards/',
      role: 'teacher',
      roleIndex: 1
    },
    {
      title: 'Багшийн бүртгэл',
      icon: 'mdi-account-multiple',
      to: '/tables/employees/',
      role: 'admin',
      roleIndex: 1
    },

    {
      title: 'Ажилчдын бүртгэл',
      icon: 'mdi-account-multiple',
      to: '/tables/employeesall/',
      role: 'admin',
      roleIndex: 1
    },


    {
      title: 'Оюутны бүртгэл',
      icon: 'mdi-account-multiple',
      to: '/tables/students/',
      role: 'admin',
      roleIndex: 2
    },
    {
      title: 'New Оюутны бүртгэл',
      icon: 'mdi-account-multiple',
      to: '/tables/newstudents/',
      role: 'admin',
      roleIndex: 2
    },
    {
      title: 'Дүнгийн бүртгэл2',
      icon: 'mdi-account-multiple',
      to: '/tables/studentsscoresmenu/',
      role: 'admin',
      roleIndex: 2
    },
    {
      title: 'Статистик',
      icon: 'mdi-account-multiple',
      to: '/tables/statistics/',
      role: 'admin',
      roleIndex: 2
    },
    {
      title: 'Дүн xайx',
      icon: 'mdi-badge-account-horizontal-outline',
      to: '/tables/searchscores/',
      role: 'admin',
      roleIndex: 2
    },
    {
      title: 'Диплом',
      icon: 'mdi-badge-account-horizontal-outline',
      to: '/tables/diplomastudents/',
      role: 'admin',
      roleIndex: 2
    },
    {
      title: 'Кредит дүйцүүлэлт',
      icon: 'mdi-badge-account-horizontal-outline',
      to: '/tables/studentsscorecomparison/',
      role: 'admin',
      roleIndex: 2
    },
    {
      title: 'Дүйцүүлэлт баталгаажуулаx',
      icon: 'mdi-badge-account-horizontal-outline',
      to: '/tables/scoreconfirmation/',
      role: 'admin',
      roleIndex: 2
    },
    {
      title: 'Дүнгийн арxив',
      icon: 'mdi-badge-account-horizontal-outline',
      to: '/tables/scoreconflictanalysis/',
      role: 'admin',
      roleIndex: 2
    },
    {
      title: 'Төлбөр/Тооцоо',
      icon: 'mdi-account-multiple',
      to: '/tables/studentpayments/',
      role: 'admin',
      roleIndex: 2
    },
    {
      title: 'Тооцоо2',
      icon: 'mdi-account-multiple',
      to: '/tables/paymentregister/',
      role: 'admin',
      roleIndex: 2
    },
    {
      title: 'Тогтмол мэдээлэл',
      icon: 'mdi-clipboard-outline',
      to: '/tables/settingtables/',
      role: 'admin',
      roleIndex: 3
    },
  ],
  menuesForAccountant: [
    {
      title: 'Багшийн бүртгэл',
      icon: 'mdi-account-multiple',
      to: '/tables/employees/',
      roleIndex: 2
    },

    {
      title: 'Ажилчдын бүртгэл',
      icon: 'mdi-account-multiple',
      to: '/tables/employeesall/',
      roleIndex: 2
    },
    {
      title: 'Төлбөр/Тооцоо',
      icon: 'mdi-account-multiple',
      to: '/tables/studentpayments/',
      roleIndex: 2
    },

    {
      title: 'Тооцоо2',
      icon: 'mdi-account-multiple',
      to: '/tables/paymentregister/',
      role: 'admin',
      roleIndex: 2
    },
  ],
  menuesForDiplomaOrganizator: [
    {
      title: 'Диплом',
      icon: 'mdi-badge-account-horizontal-outline',
      to: '/tables/diplomastudents/',
      role: 'admin',
      roleIndex: 2
    },
    {
      title: 'Дүнгийн бүртгэл',
      icon: 'mdi-account-multiple',
      to: '/tables/studentsscoresmenu/',
      role: 'admin',
      roleIndex: 2
    },
  ]

}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    //
  },
}

const getters = {}
import { mapState } from "vuex";
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    console.log()
  }
}
